import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TSizeAndCount } from '@monorepo/types';

@Component({
  selector: 'monorepo-wip-validation-error-modal',
  templateUrl: './wip-validation-error-modal.component.html',
  styleUrls: ['./wip-validation-error-modal.component.scss'],
})
export class WipValidationErrorModalComponent implements OnInit {
  @Input() errorTxt = '';
  @Input() sizeAndCountList: TSizeAndCount[] = [];

  constructor(private modalCtrl: ModalController) {}

  ngOnInit(): void {}

  dismissModal() {
    this.modalCtrl.dismiss();
  }
}
